import React from "react";
import { Redirect } from "react-router-dom";

/**
 * Dashboard e Relatórios — desativados (01/09/2026).
 *
 * Motivo: custo. O COUNT do dashboard, sem período informado, conta TODAS as
 * mensagens da empresa — 14.950 ms para 1.056.383 linhas em produção.
 *
 * Bloqueia a rota, não só o menu: link salvo e favorito também caem aqui.
 *
 * Para liberar num navegador (suporte, ou um cliente específico):
 *
 *     localStorage.setItem("telasDeAnalise", "true")
 *
 * try/catch porque o localStorage pode lançar em janela privada — sem isso a
 * exceção derrubaria a tela.
 */
export function telasDeAnaliseHabilitadas() {
  try {
    return localStorage.getItem("telasDeAnalise") === "true";
  } catch (e) {
    return false;
  }
}

export default function RotaDeAnalise({ component: Component, ...props }) {
  if (telasDeAnaliseHabilitadas()) return <Component {...props} />;
  return <Redirect to={{ pathname: "/tickets" }} />;
}
